module.exports = __webpack_public_path__ + "img/mood.d88636d3.svg";